import type { ComponentProps } from "react";

export type SiteImage = {
  src: string;
  width: number;
  height: number;
  alt: string;
  variants?: readonly { src: string; width: number }[];
};

type ResponsiveImageProps = Omit<
  ComponentProps<"img">,
  "alt" | "height" | "src" | "srcSet" | "width"
> & {
  image: SiteImage;
  priority?: boolean;
};

export default function ResponsiveImage({
  image,
  priority = false,
  sizes,
  ...props
}: ResponsiveImageProps) {
  const variants = image.variants;
  const fallback = variants?.at(-1)?.src ?? image.src;
  const srcSet = variants?.map((v) => `${v.src} ${v.width}w`).join(", ");

  return (
    <picture>
      {srcSet ? (
        <source type="image/webp" srcSet={srcSet} sizes={sizes} />
      ) : null}
      <img
        {...props}
        src={fallback}
        srcSet={srcSet}
        sizes={sizes}
        width={image.width}
        height={image.height}
        alt={image.alt}
        loading={priority ? "eager" : "lazy"}
        fetchPriority={priority ? "high" : "auto"}
        decoding="async"
      />
    </picture>
  );
}
